// component
import SvgColor from '../../../components/svg-color';


// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;


// const usuario = JSON.parse(localStorage.getItem('userData'))

const navConfig = [
  {
    title: 'Home',
    path: '/home',
    icon: icon('ic_analytics'),
    supervisor: false
  },
  {
    title: 'Produtos',
    path: '/produtos',
    icon: icon('ic_cart'),
    supervisor: false
  },
  {
    title: 'Kits',
    path: '/kits',
    icon: icon('layers-outline'),
    supervisor: false
  },
  {
    title: 'Clientes',
    path: '/clientes',
    icon: icon('ic_user'),
    supervisor: false
  },
  {
    title: 'Propostas',
    path: '/propostas',
    icon: icon('list-outline'),
    supervisor: false
  },
  {
    title: 'Agenda',
    path: '/agenda',
    icon: icon('agenda'),
    supervisor: false
  },
  {
    title: 'Kanban',
    path: '/kanban',
    icon: icon('ic_blog'),
    supervisor: false
  },
  {
    title: 'Configurações',
    path: '/configuracao',
    icon: icon('ic_settings'),
    supervisor: true
  },
  {
    title: 'Relatórios',
    path: '/relatorios',
    icon: icon('relatorios'),
    supervisor: true
  },
  /*
  usuario.supervisor ?
    {
      title: 'Configurações',
      path: '/configuracao',
      icon: icon('ic_settings'),
    } : null
  */
].filter(Boolean);

export default navConfig;
